/**
 * Resuelve el/los id de empresa que trae un evento a sus nombres, contra el catálogo del authStore.
 *
 * El backend manda el id suelto, un array, o varios ids separados por coma/punto y coma según el
 * flujo, así que se normalizan las tres formas. Si un id no está en el catálogo se devuelve el id
 * crudo antes que un vacío.
 */
export const getCompanyNames = (companyVal: any, companies: any[]): string => {
  if (companyVal === undefined || companyVal === null) return "";

  let ids: any[] = [];
  if (Array.isArray(companyVal)) {
    ids = companyVal;
  } else if (typeof companyVal === "string") {
    ids = companyVal
      .split(/[,;]/)
      .map((s: string) => s.trim())
      .filter(Boolean);
  } else {
    ids = [companyVal];
  }

  const names = ids.map((id) => {
    const found = companies?.find((c: any) => String(c.id) === String(id));
    return found?.name || found?.description || String(id);
  });

  return names.length > 0 ? names.join(", ") : "";
};
